// src/App.js
import React, { useEffect, useState } from "react";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Layout from "./screens/Layout/Layout";
import Login from "./screens/loginPage/Login";
import PrivateRoute from "./components/Base/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { setAuthFromStorage } from "./Redux/CommonSlice/authSlice";
import Loader from "./components/Common/Loader";

function App() {
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(setAuthFromStorage());
  }, [dispatch]);


  useEffect(() => {
    // Simulate loading time
    setLoading(false);

  }, []);

  if (loading) {
    return <div className="flex items-center justify-center w-full h-screen">
      <Loader/>
    </div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login  />} />
        <Route path="*" element={<PrivateRoute element={Layout} />} />
      </Routes>
    </Router>
  );
}

export default App;
